/** @jsx jsx */
import { jsx } from '@emotion/core';

export function OrderView(props){
    return(
        <div>sfjsdflksdjfvvvvvv</div>
    )
}